<template lang="pug">
.item-actions-menu(
  :style="`top: ${top}px; left: ${left}px;`"
  v-click-outside="closeActionMenu"
)
  h4 Actions for {{ item.Number }}
  ul
    li(v-if="canCheckIn" @click="checkInBooking") Check-in
    li(v-if="canRegisterPayment" @click="openBriqDialog('register-payment-dialog')") Register Payment
    li(v-if="canShowOnPlanboard")
      a(:href="planBoardUrl") Show on planboard
    li
      a(:href="bookingDetailUrl" target="_blank") Open in new tab 
    li(v-if="canSendEmail" @click="openBriqDialog('resend-mail-dialog')") Resend mail 
    li(v-if="canNoShow" @click="openBriqDialog('no-show-dialog')") No show 
    li(v-if="canCancel" @click="openBriqDialog('cancel-booking-dialog')") Cancel booking
  .loading(v-if="loading || pending")
    Spinner
</template>

<script>
import ClickOutside from 'vue-click-outside'
import Spinner from '@v/components/Spinner.vue'

export default {
  name: 'BriqDataTableActionMenu',
  props: {
    item: Object,
    top: Number,
    left: Number,
    loading: Boolean,
  },
  components: {
    Spinner,
  },
  data() {
    return {
      pending: false,
    }
  },
  computed: {
    bookingDetailUrl() {
      return `${window.location.origin}/bookings/${this.item.Key}/view`
    },
    planBoardUrl() {
      return `${window.location.origin}/planboard?booking=${this.item.Key}&edit=0`
    },
    canCheckIn() {
      return this.item?.AttendanceStatus?.toLowerCase() !== 'checked in'
    },
    canRegisterPayment() {
      return this.item?.AmountOpen && this.item.AmountOpen > 0 ? true : false
    },
    canShowOnPlanboard() {
      return this.item?.CurrentStatusCode?.toLowerCase() === 'active'
    },
    canSendEmail() {
      return this.item?.CurrentStatusCode?.toLowerCase() === 'active'
    },
    canNoShow() {
      return this.item?.AttendanceStatus?.toLowerCase() !== 'no show'
    },
    canCancel() {
      return this.item?.CurrentStatusCode?.toLowerCase() !== 'cancelled'
    },
  },
  methods: {
    closeActionMenu() {
      this.$emit('close')
    },
    async checkInBooking() {
      this.pending = true
      const res = await this.$store.dispatch('bookings/checkInBooking', this.item?.Key)
      if (res.status === 200) {
        this.$notifySuccess('Booking successfully checked in')
        this.$store.dispatch('bookings/fetchBookings')
        this.closeActionMenu()
        this.pending = false
      } else {
        this.$notifyError('Unable to check this booking in')
        this.closeActionMenu()
        this.pending = false
      }
    },
    openBriqDialog(dialog) {
      this.$emit('openBriqDialog', dialog, this.item)
    },
  },
  directives: {
    ClickOutside,
  },
}
</script>

<style scoped lang="stylus">
.item-actions-menu
  position: absolute;
  padding: 24px;
  background-color: #fff;
  box-shadow: 0px 2px 20px 5px rgba(228, 227, 227, 0.5);
  z-index: 2;

  h4
    margin-bottom: 12px;

  ul
    list-style-type: none;
    margin-bottom: 0;

    li, a
      color: rgba(44, 51, 58, 0.5);

      &:hover
        color: #2c333a;
        cursor: pointer;

  .loading
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(0, 0, 0, 0.1);
    z-index: 10;
</style>
